import type { CSSProperties } from "react"

/**
 * Uses a single-colour SVG as an alpha mask, so the element's background (a
 * token utility such as `bg-primary`) paints it. That keeps brand artwork free
 * of colour literals and lets it follow the theme (LLD §4.3).
 */
export function maskStyle(url: string): CSSProperties {
  const image = `url("${url}")`
  return {
    maskImage: image,
    maskSize: "contain",
    maskRepeat: "no-repeat",
    maskPosition: "center",
    WebkitMaskImage: image,
    WebkitMaskSize: "contain",
    WebkitMaskRepeat: "no-repeat",
    WebkitMaskPosition: "center",
  }
}
